import "./Footer.styl";
import React from "react";
import { Link } from "react-router";
import { FormattedMessage, defineMessages } from "react-intl";
import { Container, Row, Col, Input, Button } from "reactstrap";

import { Form as NewsletterForm } from "./Form";

const AppFooter = ({ pathname, noNewsletter }) => (
  <footer>
    {!noNewsletter && <NewsletterForm />}
    <div className={!noNewsletter ? "width-wrapper" : "width-wrapper mt"}>
      <Container>
        <Row>
          <Col xs="12" sm="6">
            <Row>
              <Col xs="12">
                <div className="logo">OpiekujSie.pl</div>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <div className="copyright">© PQStudio 2016</div>
              </Col>
            </Row>
          </Col>
          <Col xs="12" sm="6">
            <ul className="menu-bottom">
              <li>
                <Link to={`/polityka-prywatnosci`}>Polityka prywatności</Link>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  </footer>
);

export default AppFooter;



/** WEBPACK FOOTER **
 ** ./src/browser/components/Footer/Footer.js
 **/